module.exports = __webpack_public_path__ + "img/objetivoss.29dd19dd.png";